/**
 * Product line is read-only from main (linked entity/client).
 * Unlinked cases show EMPTY_PRODUCT_LINE_DISPLAY until main provides data.
 */
export const EMPTY_PRODUCT_LINE_DISPLAY = "--";

export const PRODUCT_LINE_HELP_TEXT =
  "Product line comes from the client's Juniper Square account when available.";
